import { render, staticRenderFns } from "./LocaleInfoForm.vue?vue&type=template&id=18125d36&scoped=true"
import script from "./LocaleInfoForm.vue?vue&type=script&lang=js"
export * from "./LocaleInfoForm.vue?vue&type=script&lang=js"
import style0 from "./LocaleInfoForm.vue?vue&type=style&index=0&id=18125d36&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18125d36",
  null
  
)

export default component.exports